export default __webpack_public_path__ + "static/media/extend-xt.2e92145f.jpg";